import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export function useAuth() {
  const [user, setUser] = useState(null);
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setLoading(true);
      if (firebaseUser) {
        setUser(firebaseUser);

        try {
          const docRef = doc(db, "users", firebaseUser.uid);
          const userDoc = await getDoc(docRef);

          if (userDoc.exists()) {
            const data = userDoc.data();
            setIsPremium(data.role === "premium");
          } else {
            setIsPremium(false);
          }
        } catch (err) {
          console.error("Error fetching user role:", err);
          setIsPremium(false);
        }
      } else {
        setUser(null);
        setIsPremium(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { user, isPremium, loading };
}
